import React, { useReducer } from 'react';
import cloneDeep from "lodash.clonedeep";
import { Checkbox, ControlLabel, FormGroup } from "react-bootstrap";
import { eventModuleQuestionsUpdate } from '../../../../../api/cp/eventModuleQuestion';
import { useEventContext } from '../../../../context';
import locale from '../../../../locale';

const QuestionSettings = () => {
    const {event} = useEventContext();
    const [questionSettings, updateQuestionSettings] = useReducer(
        (prev, next) => {
            return {...prev, ...next}
        },
        cloneDeep(event.moduleQuestion)
    );

    const onSaveSettings = async (setting = {}) => {
        try {
            const response = await eventModuleQuestionsUpdate(event.id, setting);
            updateQuestionSettings({...questionSettings, ...response});
        } catch (e) {}
    }

    return (
        <section>
            <ControlLabel>{locale('settings.question.title')}</ControlLabel>
            <FormGroup
                id={"questionSettings"}
                className="setting-screen-wrapper__children"
            >
                <Checkbox
                    checked={questionSettings.isHide}
                    onChange={(e) => onSaveSettings({ isHide: e.target.checked })}
                >
                    {locale('settings.question.hide')}
                </Checkbox>
                <Checkbox
                    checked={questionSettings.allowReceiveQuestions}
                    onChange={(e) => onSaveSettings({ allowReceiveQuestions: e.target.checked })}
                >
                    {locale('settings.question.allowReceiveQuestions')}
                </Checkbox>
            </FormGroup>
        </section>
    )
}

export default QuestionSettings;